import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Imprimir Movimentação", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "ant-col ant-col-xs-14 ant-col-xl-14" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "ant-col ant-col-xs-14 ant-col-xl-14" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-20 ant-col-xl-20" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_28 = { class: "ant-row" }
const _hoisted_29 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = {
  key: 2,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_36 = { key: 3 }
const _hoisted_37 = { class: "ant-row" }
const _hoisted_38 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_39 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_40 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_tipo_rastreabilidade = _resolveComponent("selecionar-tipo-rastreabilidade")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_tipo_uso_arma = _resolveComponent("selecionar-tipo-uso-arma")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Detalhe da Rastreabilidade",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: 900,
    centered: "",
    "wrap-class-name": _ctx.storeSistema.state.layoutMobile?'scroll-modal ss-modal-estoque':'ss-modal-estoque'
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando,
        paragraph: { rows: 15 }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_form_item, {
                    label: "Cód. Produto",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        value: _ctx.props.rastreabilidade.codigoProduto,
                        disabled: ""
                      }, null, 8, _hoisted_5)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_a_form_item, {
                    label: "Produto",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        value: _ctx.props.rastreabilidade.descricaoProduto,
                        disabled: ""
                      }, null, 8, _hoisted_7)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_form_item, {
                    label: "Unidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        style: {"text-align":"center"},
                        value: _ctx.props.rastreabilidade.unidade,
                        disabled: ""
                      }, null, 8, _hoisted_9)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_a_form_item, {
                    label: "Identificador",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        value: _ctx.props.rastreabilidade.identificador,
                        disabled: ""
                      }, null, 8, _hoisted_12)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_form_item, {
                    label: "Descrição da Rastreabilidade",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        type: "text",
                        class: "ant-input",
                        value: _ctx.props.rastreabilidade.descricao,
                        disabled: ""
                      }, null, 8, _hoisted_14)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_rastreabilidade, {
                        valor: _ctx.props.rastreabilidade.tipo,
                        "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.props.rastreabilidade.tipo) = $event)),
                        disabled: true
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              (_ctx.props.rastreabilidade.tipo === _ctx.ETipoRastreabilidade.Lote)
                ? (_openBlock(), _createBlock(_component_card, {
                    key: 0,
                    titulo: "Detalhes do Lote"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, {
                            label: "Número do Lote",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                value: _ctx.props.rastreabilidade.numeroLote,
                                disabled: ""
                              }, null, 8, _hoisted_18)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_a_form_item, {
                            label: "Fabricação/Produção",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                value: _ctx.UtilitarioData.aplicaFormatoData(_ctx.props.rastreabilidade.dataFabricacao),
                                disabled: ""
                              }, null, 8, _hoisted_20)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createVNode(_component_a_form_item, {
                            label: "Validade",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                value: _ctx.UtilitarioData.aplicaFormatoData(_ctx.props.rastreabilidade.dataValidade),
                                disabled: ""
                              }, null, 8, _hoisted_22)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_a_form_item, {
                            label: "Preço Máximo ao Consumidor",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_campo_numerico, {
                                monetario: true,
                                valor: _ctx.props.rastreabilidade.precoMaximoConsumidor,
                                "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.props.rastreabilidade.precoMaximoConsumidor) = $event))
                              }, null, 8, ["valor"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }))
                : (_ctx.props.rastreabilidade.tipo === _ctx.ETipoRastreabilidade.Armamento)
                  ? (_openBlock(), _createBlock(_component_card, {
                      key: 1,
                      titulo: "Detalhes do Armamento"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_a_form_item, {
                              label: "Descrição",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  value: _ctx.props.rastreabilidade.descricaoArmamento,
                                  disabled: ""
                                }, null, 8, _hoisted_26)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_a_form_item, {
                              label: "Tipo Uso",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_selecionar_tipo_uso_arma, {
                                  valor: _ctx.props.rastreabilidade.TipoUsoArma,
                                  "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.props.rastreabilidade.TipoUsoArma) = $event)),
                                  disabled: true
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createVNode(_component_a_form_item, {
                              label: "Número de Série da Arma",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  value: _ctx.props.rastreabilidade.numeroSerieArma,
                                  disabled: ""
                                }, null, 8, _hoisted_30)
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_a_form_item, {
                              label: "Número de Série do Cano",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  value: _ctx.props.rastreabilidade.numeroSerieCano,
                                  disabled: ""
                                }, null, 8, _hoisted_32)
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
              _createVNode(_component_card, {
                titulo: "RASTREABILIDADES",
                class: "ss-padding-separacao-esquerda"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_table, {
                    columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                    "data-source": _ctx.state.movimentos,
                    rowKey: "codigo",
                    pagination: false,
                    loading: _ctx.gradeBase.buscandoDados,
                    size: "small"
                  }, {
                    bodyCell: _withCtx(({ column, record, text }) => [
                      (column.key === 'Quantidade')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, _ctx.props.rastreabilidade.casasDecimais, false, true)), 1))
                        : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(text)), 1))
                          : (column.key === 'Movimento')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("span", null, "Data: " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(record.dataMovimento)), 1),
                                _createElementVNode("span", null, "Nº do Movimento: " + _toDisplayString(record.numeroMovimento), 1),
                                _createElementVNode("span", null, "Origem do Movimento: " + _toDisplayString(record.descricaoRecurso), 1),
                                _createElementVNode("span", null, "Cliente/Fornecedor: " + _toDisplayString(record.nomePessoa), 1),
                                _createElementVNode("span", null, "Quantidade: " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, _ctx.props.rastreabilidade.casasDecimais, false, true)), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(text), 1))
                    ]),
                    emptyText: _withCtx(() => [
                      _createVNode(_component_mensagem_sem_dados, {
                        resultadoPesquisa: true,
                        mensagem: "Nenhum movimento encontrado."
                      })
                    ]),
                    _: 1
                  }, 8, ["columns", "data-source", "loading"]),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_a_form_item, {
                        label: "Entradas",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.state.entradas,
                            "quantidade-casas-decimais": _ctx.props.rastreabilidade.casasDecimais,
                            disabled: true
                          }, null, 8, ["valor", "quantidade-casas-decimais"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_a_form_item, {
                        label: "Saídas",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            valor: _ctx.state.saidas,
                            "quantidade-casas-decimais": _ctx.props.rastreabilidade.casasDecimais,
                            disabled: true
                          }, null, 8, ["valor", "quantidade-casas-decimais"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_a_form_item, {
                        label: "Saldo",
                        class: "ss-margin-campos"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_campo_numerico, {
                            valor: (_ctx.state.entradas + _ctx.state.saidas),
                            "quantidade-casas-decimais": _ctx.props.rastreabilidade.casasDecimais,
                            disabled: true,
                            permitirValorNegativo: true
                          }, null, 8, ["valor", "quantidade-casas-decimais"])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_requisicao_modal, {
        visivel: _ctx.modalBase.exibirRequisicaoModal,
        "onUpdate:visivel": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
        retornoRequisicao: _ctx.modalBase.retornoRequisicao,
        apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
        fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
      }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"]),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible", "wrap-class-name"]))
}